import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import Toolbar from '@mui/material/Toolbar'
import moment from 'moment'
import { func } from 'prop-types'
import { CvsDatePicker } from '@components'
import { t } from '@lingui/core/macro'

const MarginRight = styled.div`
  margin-right: 12px;
`

const today = moment().endOf('day')

const threeMonthsAgo = moment().subtract(3, 'months')

export const CvsDateRangeToolbar = ({ filterChanged = () => {} }) => {
  const [startDate, setStartDate] = useState(threeMonthsAgo)
  const [endDate, setEndDate] = useState(today)

  useEffect(() => filterChanged({ startDate, endDate }), [startDate, endDate, filterChanged])

  const handleStartChange = value => {
    setStartDate(moment(value).startOf('day'))
  }

  const handleEndChange = value => {
    setEndDate(moment(value).endOf('day'))
  }

  return (
    <Toolbar>
      <MarginRight>
        <CvsDatePicker
          color="primary"
          margin="dense"
          inputFormat="YYYY-MM-DD"
          label={t`Start date`}
          handleChange={handleStartChange}
          value={startDate}
        />
      </MarginRight>
      <CvsDatePicker
        color="primary"
        margin="dense"
        inputFormat="YYYY-MM-DD"
        label={t`End date`}
        handleChange={handleEndChange}
        value={endDate}
      />
    </Toolbar>
  )
}

CvsDateRangeToolbar.propTypes = {
  filterChanged: func,
}
